import { WebPlugin } from '@capacitor/core';
export class ContentsquareCAPWeb extends WebPlugin {
    async sendTransaction(_transactionItem) {
        throw new Error('Method not implemented.');
    }
    async sendDynamicVarWithIntValue(_dynamicVarItem) {
        throw new Error('Method not implemented.');
    }
    async sendDynamicVarWithStringValue(dynamicVarItem) {
        console.log('sendDynamicVarWithStringValue', dynamicVarItem);
        throw new Error('Method not implemented.');
    }
    async sendScreenName(_options) {
        throw new Error('Method sendScreenName not implemented.');
    }
    async optIn() {
        throw new Error('Method optIn not implemented.');
    }
    async optOut() {
        throw new Error('Method optOut not implemented.');
    }
    async excludeURLForReplay(_options) {
        throw new Error('Method excludeURLForReplay not implemented.');
    }
    async setPIISelectors(_pii) {
        throw new Error('Method excludeURLForReplay not implemented.');
    }
    async setCapturedElementsSelector(_options) {
        throw new Error('Method excludeURLForReplay not implemented.');
    }
    async onReady() {
        throw new Error('Method onReady not implemented.');
    }
    async collect(_telemetryItem) {
        throw new Error('Method collect not implemented.');
    }
}
//# sourceMappingURL=web.js.map